import type { PaymentTerm } from '@/features/accounting-tax/api'

type MatchablePaymentTerm = Pick<PaymentTerm, 'id' | 'code' | 'name' | 'net_days'>

export function matchPaymentTerm<Term extends MatchablePaymentTerm>(
  terms: readonly Term[],
  partyTerms: string,
): Term | undefined {
  const normalizedTerms = partyTerms.toLowerCase()

  return (
    terms.find((term) => term.code.toLowerCase() === normalizedTerms) ??
    terms.find((term) =>
      Object.values(term.name).some((name) => name.toLowerCase() === normalizedTerms),
    ) ??
    terms.find((term) => term.net_days !== null && partyTerms.includes(String(term.net_days)))
  )
}
